import { ResourceProps } from "@refinedev/core";
import { TeamOutlined } from "@ant-design/icons";

export const adminAccessResource: ResourceProps = {
  name: "admin-access",
  meta: {
    icon: <TeamOutlined />,
    label: "Пользователи и роли",
  },
  list: "/admin-access",
};
